export const toUTCWithOffset = (date: Date, offsetMinutes?: number): Date => {
    const offset = offsetMinutes !== undefined ? offsetMinutes * 60 * 1000 : 0
    const utcTime = new Date(date.getTime() - offset + 13000)
    return utcTime
}
